import { render, staticRenderFns } from "./TipoSensorIndex.vue?vue&type=template&id=75bd3a63&scoped=true&"
import script from "./TipoSensorIndex.vue?vue&type=script&lang=js&"
export * from "./TipoSensorIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bd3a63",
  null
  
)

export default component.exports